import { Link } from 'react-router-dom';
import { Calculate, Phone, Email, LocationOn, Facebook, Instagram, LinkedIn, WhatsApp } from '@mui/icons-material';
import { motion } from 'framer-motion';
import {
  FooterWrapper,
  FooterContent,
  FooterSection,
  FooterTitle,
  FooterLink,
  FooterText,
  CalculatorLink,
  SocialMediaContainer,
  SocialIcon,
  FooterBottom,
  NewsletterSection,
  NewsletterInput,
  SubscribeButton,
  ContactItem
} from './styles';

const Footer = () => {
  const fadeIn = {
    initial: { opacity: 0, y: 20 },
    animate: { opacity: 1, y: 0 },
    transition: { duration: 0.6 }
  };

  return (
    <FooterWrapper>
      <FooterContent>
        <motion.div {...fadeIn}>
          <FooterSection>
            <FooterTitle>צור קשר</FooterTitle>
            <ContactItem>
              <Phone sx={{ marginLeft: 1 }} /> 
              <FooterText href="tel:054-882-7511">054-882-7511</FooterText>
            </ContactItem>
            <ContactItem>
              <Email sx={{ marginLeft: 1 }} />
              <FooterText href="mailto:afiklev@gmail.com">afiklev@gmail.com</FooterText>
            </ContactItem>
            <ContactItem>
              <LocationOn sx={{ marginLeft: 1 }} />
              <FooterText>שירות בפריסה ארצית</FooterText>
            </ContactItem>
          </FooterSection>
        </motion.div>

        <motion.div {...fadeIn} transition={{ delay: 0.2 }}>
          <FooterSection>
            <FooterTitle>שירותים</FooterTitle>
            <FooterLink as={Link} to="/services/first">משכנתא לדירה ראשונה</FooterLink>
            <FooterLink as={Link} to="/services/refinance">מחזור משכנתא</FooterLink>
            <FooterLink as={Link} to="/services/investment">משכנתא להשקעה</FooterLink>
            <FooterLink as={Link} to="/services/general">משכנתא לכל מטרה</FooterLink>
            <CalculatorLink as={Link} to="/calculator">
              <Calculate sx={{ marginLeft: 1 }} />
              מחשבון משכנתא
            </CalculatorLink>
          </FooterSection>
        </motion.div>

        <motion.div {...fadeIn} transition={{ delay: 0.4 }}>
          <FooterSection>
            <FooterTitle>הצטרפו לניוזלטר שלנו</FooterTitle>
            <NewsletterSection>
              <NewsletterInput placeholder="הזינו את האימייל שלכם" />
              <SubscribeButton>הרשמה</SubscribeButton>
            </NewsletterSection>
            <SocialMediaContainer>
              <SocialIcon href="https://facebook.com" target="_blank">
                <Facebook />
              </SocialIcon>
              <SocialIcon href="https://instagram.com" target="_blank">
                <Instagram />
              </SocialIcon>
              <SocialIcon href="https://linkedin.com" target="_blank">
                <LinkedIn />
              </SocialIcon>
              <SocialIcon href="https://wa.me/972548827511" target="_blank">
                <WhatsApp />
              </SocialIcon>
            </SocialMediaContainer>
          </FooterSection>
        </motion.div>
      </FooterContent>
      
      <FooterBottom>
        <FooterText>© 2024 כל הזכויות שמורות | <Link to="/privacy" style={{ color: '#D2A46E', textDecoration: 'none' }}>מדיניות פרטיות</Link></FooterText>
        <div style={{ 
          textAlign: 'center', 
          marginTop: '20px',
          '@media (max-width: 768px)': {
            marginTop: '15px'
          }
        }}>
          <FooterText style={{ 
            marginBottom: '12px', 
            fontSize: '14px',
            '@media (max-width: 768px)': {
              fontSize: '13px',
              marginBottom: '10px'
            }
          }}>
            האתר נבנה על ידי
          </FooterText>
          <a 
            href="https://natimarketing.co.il" 
            target="_blank" 
            rel="noopener noreferrer"
            style={{ 
              display: 'inline-block',
              transition: 'all 0.3s ease'
            }}
            onMouseEnter={(e) => {
              e.target.style.transform = 'scale(1.1)';
              e.target.style.opacity = '0.8';
            }}
            onMouseLeave={(e) => {
              e.target.style.transform = 'scale(1)';
              e.target.style.opacity = '1';
            }}
            title="פותח על ידי נתי מימון - לחץ לאתר"
          >
            <img 
              src="/images/logo nati.svg" 
              alt="נתי מימון - פיתוח אתרים" 
              style={{ 
                width: '36px', 
                height: '36px',
                filter: 'brightness(0) saturate(100%) invert(69%) sepia(20%) saturate(1234%) hue-rotate(21deg) brightness(96%) contrast(85%)',
                display: 'block'
              }} 
            />
          </a>
        </div>
      </FooterBottom>
    </FooterWrapper>
  );
};

export default Footer; 